import {Component, React, observer} from '$src/handy'
import * as css from './EditLocationModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {getSnapshot} from 'mobx-state-tree'
import editHousingCorporationAddress from '$src/api/endpoints/housingCorporations/editHousingCorporationAddress'


interface Props {
  onRequestClose: Function
  cid: string | number
  onUpdateNeeded: Function
}

interface State {
  error?: string
  submitting: boolean
}

@observer
export default class EditAddressModal extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, submitting: false}
  }

  onSubmit = (fields: {address: string;}) => {
    this.setState({error: undefined, submitting: true})

    /**
     * Capitalize the first letter for the field data
     * (for the location coordinates to work properly)
     */
    const regex = /(\b[a-z](?!\s))/g
    const address = fields.address.replace(regex, function(field: string) {
      return field.toUpperCase()
    })

    this.callEndpoint(editHousingCorporationAddress, {
      address,
      cid: this.props.cid,
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded(address)
        this.props.onRequestClose()
      },
      (error: any) => {
        this.setState(s => ({
          ...s,
          error: error.message || 'Unauthorized',
          submitting: false,
        }))
      },
    )
  }

  render() {
    const {props} = this

    let initialValues = undefined
    const data: {address?: string;} = getSnapshot(
      // @ts-ignore
      this.store.housingCorporations.byId.get(props.cid),
    )
    initialValues = {
      address: data.address,
    }

    return (
      <GenericModal
        onHide={props.onRequestClose}
        css={{box: {container: css.box}}}
      >
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field name="address" type="text" label="ADDRESS" />
          <div className={css.bottom}>
            {this.state.error && (
              <div className={css.error}>Error occured: {this.state.error}</div>
            )}
            <GenericButton
              variant="bold"
              type="submit"
              disabled={this.state.submitting}
            >
              EDIT Address
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/EditAddressModal.tsx